import { NumericFormatUtil } from "store/types";
import { useNumberFormatSelector } from "store";
import { numericToAbbreviated } from "utils";

// Format number or string like number to abbreviated string
// According to account number format if external was not provided
export function useFormatNumericHook(): NumericFormatUtil {
  const numberFormat = useNumberFormatSelector();

  return ({ value, format = {} }) => {
    return numericToAbbreviated({
      value: value,
      format: {
        abbreviated: format.abbreviated ?? numberFormat.abbreviated,
        decimal: format.decimal ?? numberFormat.decimal
      }
    });
  };
}
